export const AUTH_LOGOUT = "AUTH_LOGOUT";
